import CustomSelect from "@Common/CustomSelect"
import Input from "@Common/input"
import { useGetGetTeamMemberRoles } from "@services"
import { FORM_REGEX_VALIDATORS } from "@utils"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"

export default function FormInputsNewMember() {
	const { t } = useTranslation()
	const { data } = useGetGetTeamMemberRoles({})
	/* ---------------------------------- Hooks --------------------------------- */
	const {
		i18n: { language },
	} = useTranslation()

	const listOfPremissions = useMemo(() => {
		const dataList = data?.result.map((item) => {
			return {
				label: language === "en" ? item.roleName : item.roleNameAr,
				value: item.roleId.toString(),
			}
		})
		return dataList ?? []
	}, [data, language])
	return (
		<div>
			<Input
				label={t("UserManagement.name")}
				placeholder={t("UserManagement.name")}
				name='fullName'
				registerOptions={{
					required: {
						value: true,
						message: t("COMMON.REQUIRED"),
					},
				}}
			/>
			<Input
				label={t("UserManagement.email")}
				placeholder={t("UserManagement.email")}
				name='email'
				type="email"
				registerOptions={{
					required: {
						value: true,
						message: t("COMMON.REQUIRED"),
					},
					pattern: {
						value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
						message: t("UserManagement.please_enter_valid_email") || "Please enter a valid email address",
					},
				}}
			/>
			<Input
				name='phoneNumber'
				label={t("UserManagement.phone_number")}
				placeholder={t("UserManagement.phone_number")}
				registerOptions={{
					required: {
						value: true,
						message: t("COMMON.REQUIRED"),
					},
					pattern: {
						value: FORM_REGEX_VALIDATORS.phone,
						message: t(
							"UserManagement.please_enter_the_mobile_number_correctly"
						),
					},
				}}
			/>
			<CustomSelect
				data={listOfPremissions}
				label={t("UserManagement.team_member_role")}
				name='roleId'
				registerOptions={{
					required: {
						value: true,
						message: t("COMMON.REQUIRED"),
					},
				}}
			/>
		</div>
	)
}
